<template>
  <div>
    <nested-navigation class="mb-12" :links="subMenus"></nested-navigation>
    <router-view :key="$route.path"></router-view>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import NestedNavigation from '../Common/NestedNavigation.vue';
export default {
  components: { NestedNavigation },
  mounted() {
    this.subMenuSelect();
  },
  computed: {
    ...mapState(['globalNav']),
    subMenus() {
      return this.menuData.map(menu => ({
        ...menu,
        active: menu.meta?.fromType === this.$route.meta?.fromType
      }));
    }
  },
  methods: {
    subMenuSelect() {
      const subMenus = this.globalNav.find(
        element => element.parent === this.title
      );

      if (subMenus) {
        const menuData = subMenus.children[this.index].children
          .filter(menu => menu.title)
          .filter(menu =>
            menu.permission ? this.checkPermissions(menu.permission) : true
          );
        const activeVault = this.connectorArchiveNameMap(
          null,
          'consentMenu',
          'currentOrgActiveConnectors'
        );
        if (activeVault.length && this.index === 1) {
          this.menuData = [...activeVault, ...menuData];
        } else {
          this.menuData = menuData;
        }
      }
    }
  },
  data() {
    return {
      menuData: []
    };
  },
  props: ['title', 'index']
};
</script>
